import React, { createContext, useState, useContext, useCallback } from 'react';

const FoxContext = createContext();

export const useFox = () => useContext(FoxContext);

export const FoxProvider = ({ children }) => {
  const [foxState, setFoxState] = useState({
    isVisible: false,
    position: 'bottom-right', 
    messageKey: '', 
    mood: 'happy',
    action: null,
    imageOverride: null // YENİ: Özel resim (Büyüteçli vb.) tanımlamak için
  });

  const triggerFox = useCallback((messageKey, options = {}) => {
    // Eğer zaten açıksa önce kapat (Animasyon resetlensin)
    setFoxState(prev => ({ ...prev, isVisible: false }));

    setTimeout(() => {
        setFoxState({
            isVisible: true,
            messageKey,
            position: options.position || 'bottom-right',
            mood: options.mood || 'happy',
            action: options.action || null,
            imageOverride: options.imageOverride || null // YENİ: Seçeneklerden al
        });
    }, 100);

    // 8 saniye sonra otomatik kaybolsun
    setTimeout(() => {
        setFoxState(prev => ({ ...prev, isVisible: false }));
    }, 8000);
  }, []);

  const hideFox = useCallback(() => {
    setFoxState(prev => ({ ...prev, isVisible: false }));
  }, []);

  return (
    <FoxContext.Provider value={{ foxState, triggerFox, hideFox }}>
      {children}
    </FoxContext.Provider>
  );
};